import { JL } from 'jsnlog'

// JsnlogPlugin injects $jsnLog to Vue.prototype.
// Vue.prototype.$jsnLog is the jsnLog logger object named by customLoggerName.
// jsnlog('onerrorLogger') will also use the options useConsoleLog, useAjaxLog, ajaxLogUrl.
// Mixins: errorCaptured().
const JsnlogPlugin = {
  install(Vue, options) {
    var customLoggerName = 'jsnlog'
    var useAjaxLog = false
    var useConsoleLog = true
    var ajaxLogLevel = JL.getAllLevel()
    var ajaxLogStoreInBufferLevel = JL.getAllLevel()
    var ajaxLogSendWithBufferLevel = JL.getFatalLevel()
    var ajaxLogBufferSize = 10
    var ajaxLogMaxBatchSize = 20
    var ajaxLogBatchSize = 1
    var ajaxLogSendTimeout = 5000 // milliseconds
    var ajaxLogUrl = '/jsnlog.logger'
    var consoleLogLevel = JL.getAllLevel()
    var passThroughError = true

    var ajaxLogAppender
    var consoleLogAppender
    var appenders = []

    var onerrorLoggerOptions = {}
    var funcGetCustomLogger

    if (options) {
      if ('undefined' !== typeof options.customLoggerName) {
        customLoggerName = options.customLoggerName
      }
      if ('undefined' !== typeof options.useAjaxLog) {
        useAjaxLog = options.useAjaxLog
      }
      if ('undefined' !== typeof options.useConsoleLog) {
        useConsoleLog = options.useConsoleLog
      }
      if ('undefined' !== typeof options.ajaxLogLevel) {
        ajaxLogLevel = options.ajaxLoglevel
      }
      if ('undefined' !== typeof options.ajaxLogStoreInBufferLevel) {
        ajaxLogStoreInBufferLevel = options.ajaxLogStoreInBufferLevel
      }
      if ('undefined' !== typeof options.ajaxLogSendWithBufferLevel) {
        ajaxLogSendWithBufferLevel = options.ajaxLogSendWithBufferLevel
      }
      if ('undefined' !== typeof options.ajaxLogBufferSize) {
        ajaxLogBufferSize = options.ajaxLogBufferSize
      }
      if ('undefined' !== typeof options.ajaxLogMaxBatchSize) {
        ajaxLogMaxBatchSize = options.ajaxLogMaxBatchSize
      }
      if ('undefined' !== typeof options.ajaxLogBatchSize) {
        ajaxLogBatchSize = options.ajaxLogBatchSize
      }
      if ('undefined' !== typeof options.ajaxLogSendTimeout) {
        ajaxLogSendTimeout = options.ajaxLogSendTimeout
      }
      if ('undefined' !== typeof options.ajaxLogUrl) {
        ajaxLogUrl = options.ajaxLogUrl
      }
      if ('undefined' !== typeof options.consoleLogLevel) {
        consoleLogLevel = options.consoleLogLevel
      }
      if ('undefined' !== typeof options.passThroughError) {
        passThroughError = options.passThroughError
      }
    }

    // Set up jsnlog logger.
    if (useAjaxLog) {
      ajaxLogAppender = JL.createAjaxAppender('ajaxAppender')
      ajaxLogAppender.setOptions({
        'level': ajaxLogLevel,
        'storeInBufferLevel': ajaxLogStoreInBufferLevel,
        'sendWithBufferLevel': ajaxLogSendWithBufferLevel,
        'bufferSize': ajaxLogBufferSize,
        'maxBatchSize': ajaxLogMaxBatchSize,
        'batchSize': ajaxLogBatchSize,
        'sendTimeout': ajaxLogSendTimeout,
        'url': ajaxLogUrl,
      })
      appenders.push(ajaxLogAppender)
    }

    if (useConsoleLog) {
      consoleLogAppender = JL.createConsoleAppender('consoleAppender')
      consoleLogAppender.setOptions({
        'level': consoleLogLevel,
      })
      appenders.push(consoleLogAppender)
    }

    // JSNLog built-in window.onerror handler.
    onerrorLoggerOptions['appenders'] = appenders
    JL('onerrorLogger').setOptions(onerrorLoggerOptions)

    // Custom logger name
    JL(customLoggerName).setOptions({
      'appenders': appenders,
    })

    // Inject $jsnLog to Vue.prototype.
    funcGetCustomLogger = function() {
      return JL(customLoggerName)
    }
    Vue.prototype.$jsnLog = funcGetCustomLogger

    // Inject some component options through mixin.
    Vue.mixin({
      errorCaptured(err, vm, info) {
        funcGetCustomLogger().fatal('URL: ' + window.location + '\n; Vue lifecycle hook: ' + info + '\n ; stack trace:\n' + err.stack)

        // You can return false to prevent the error from propogating further.
        return passThroughError
      },
    })
  },
}

export default JsnlogPlugin

// Example of using injected property:
// this.$jsnLog().fatal('URL: ' + this.$route.fullPath + '\n; Vue lifecycle hook: ' + info + '\n ; stack trace:\n' + err.stack)